import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B6({data, globalVariables, assoc_data, message_key, extra_data}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XS01.error_id: {
            return (
                <>
                    <ResultText>
                        The Downstream Channel Reach Length of the cross section is not equal to the RS of that cross section minus RS of the next downstream cross section at the following {row?.data?.length} river stations.
                        The cumulative error is {row.cumm_error} ft.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>DS RL Channel</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Error (ft)</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.channel}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.error}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XS02.error_id: {
            return (
                <>
                    <ResultText>
                        The DS reach length along the overbank is significantly (x {settings?.thresholds?.max_ob_channel}) different than that along channel at the following {row?.data?.length} cross sections. Negative sign indicates Overbank Length is shorter than the Channel Length.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(15)}}>DS RL Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>LOB Ratio</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>ROB Ratio</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(15)}}>{r.chn}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>
                                            <span style={{color: Math.abs(parseFloat(r.LOB_OBRL)) > settings?.thresholds?.max_ob_channel ? 'red' : ''}}>{r.LOB_OBRL}</span>
                                        </ResultBodyCell>
                                        <ResultBodyCell
                                            style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>
                                            <span style={{color: Math.abs(parseFloat(r.ROB_OBRL)) > settings?.thresholds?.max_ob_channel ? 'red' : '', fontWeight: 'normal'}}>{r.ROB_OBRL}</span>
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XS03.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    The downstream reach length along left overbank (LOB) is significantly longer than that along channel at RS <CheckCSName csName={x.cross_section} />.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}